if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.button = this.querySelector('.load-more');
      this.grid = document.getElementById('product-grid');
      if (!this.button || !this.grid) return;
      this.controller = new AbortController();
      this.button.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.loadProducts();
      }, { signal: this.controller.signal });
      if (this.classList.contains('pagination-type--infinite') && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadProducts();
        }, { rootMargin: '200px 0px' });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.removeAttribute('loading');
    }

    async loadProducts() {
      if (!this.controller || this.hasAttribute('loading') || this.hidden) return;
      const controller = this.controller;
      const grid = this.grid;
      const url = this.button.getAttribute('href');
      if (!url) return;
      this.setAttribute('loading', 'true');
      this.button.setAttribute('aria-disabled', 'true');
      grid.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Pagination request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || controller.signal.aborted) return;
        const nextGrid = html.getElementById('product-grid');
        if (!nextGrid) throw new Error('Product grid missing');
        const products = Array.from(nextGrid.children);
        const nextPagination = html.querySelector('pagination-theme');
        const nextUrl = nextPagination?.querySelector('.load-more')?.getAttribute('href');
        if (nextUrl === url) throw new Error('Pagination did not advance');
        grid.append(...products);
        if (window.lazySizes?.loader) {
          products.forEach((product) => product.querySelectorAll('.lazyload').forEach((image) => {
            window.lazySizes.loader.unveil(image);
          }));
        }
        if (nextUrl && products.length) {
          this.button.setAttribute('href', nextUrl);
        } else {
          this.hidden = true;
          this.observer?.disconnect();
        }
        this.dispatchEvent(new CustomEvent('pagination:page-changed', { bubbles: true, detail: { url } }));
        if (typeof window.StampedFn?.loadBadges === 'function') window.StampedFn.loadBadges();
      } catch (error) {
        if (error.name !== 'AbortError') this.observer?.disconnect();
      } finally {
        grid.removeAttribute('aria-busy');
        if (this.controller === controller) {
          this.removeAttribute('loading');
          this.button.removeAttribute('aria-disabled');
        }
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
